/** SSE 重连补拉待处理记录；网络失败由调用方重试，切换身份立即丢弃旧结果。 */
export async function reconcilePendingNotifications<T extends { id: string | number }>(
  fetchPage: (page: number, pageSize: number) => Promise<{ list: T[]; total: number }>,
  consume: (item: T) => void,
  isCurrent: () => boolean,
): Promise<void> {
  const seen = new Set<string>();
  const pageSize = 100;
  let pageCount = 1;
  for (let page = 1; page <= pageCount && isCurrent(); page += 1) {
    const result = await fetchPage(page, pageSize);
    if (!isCurrent()) return;
    if (page === 1) pageCount = Math.max(1, Math.ceil(result.total / pageSize));
    if (!Number.isFinite(pageCount) || pageCount > 1000) throw new Error('通知分页数量异常');
    for (const item of result.list) {
      if (!isCurrent()) return;
      const key = String(item.id);
      if (!seen.has(key)) {
        seen.add(key);
        consume(item);
      }
    }
    if (result.list.length === 0) return;
  }
}
